module.exports = __webpack_public_path__ + "static/scenario1-thumb-c980b826870a64c41a5a72f17f381b4b.png";